import { GetHeaderRes } from "../network/UserApi/userInterfaces";

interface IProps {
  header: GetHeaderRes;
}

const UserPage = (props: IProps) => {
  const renderedAccs = props.header.accounts?.map((acc) => {
    return <p>{acc.account}</p>;
  });
  return (
    <div>
      <div className="flex justify-between flex-row">
        <p>
          <b>Имя:</b> {props.header.name}
        </p>
        <div>
          <p>Аккаунты:</p>
          {renderedAccs}
        </div>
        <p>
          fxCode: <b>{props.header.fxCode}</b>
        </p>
      </div>
    </div>
  );
};

export default UserPage;
